import { Fragment } from 'react'

import { getTableRowQaProps } from '../../Table'

import { renderCell } from './EpostValidationErrorsTableRow.utils'

function EpostValidationErrorsTableRow({
  cellClassName,
  className,
  columns,
  item,
  ...renderCellProps
}) {
  const qaProps = getTableRowQaProps()

  return (
    <div {...qaProps} className={className} key={item.id}>
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            ...renderCellProps,
            className: cellClassName,
            item,
            name: column.name,
          })}
        </Fragment>
      ))}
    </div>
  )
}

export default EpostValidationErrorsTableRow
